import { Button } from '@/components/ui/button';
import { Edit, Trash2, Eye } from 'lucide-react';

/**
 * Renders a row of icon buttons for DataTable action cells.
 * Each action: { icon, onClick, className?, title?, show? }
 */
export default function ActionButtons({ actions }) {
  return (
    <div className="flex justify-end gap-2">
      {actions.map((action, i) => {
        if (action.show === false) return null;
        return (
          <Button
            key={i}
            variant="outline"
            size="sm"
            onClick={(e) => { e.stopPropagation(); action.onClick(); }}
            className={action.className}
            title={action.title}
          >
            {action.icon}
          </Button>
        );
      })}
    </div>
  );
}

/** Predefined action builders */
export const editAction = (handler) => ({
  icon: <Edit className="w-4 h-4" />,
  onClick: handler,
  title: 'Измени',
});

export const deleteAction = (handler) => ({
  icon: <Trash2 className="w-4 h-4" />,
  onClick: handler,
  className: 'text-red-600 hover:text-red-700 hover:bg-red-50',
  title: 'Избриши',
});

export const viewAction = (handler) => ({
  icon: <Eye className="w-4 h-4" />,
  onClick: handler,
  title: 'Преглед',
});
